export type TalentInsightsStreamInput = {
	userID: string;
	templateID: string;
	groupID: string;
	localDate: string;
	locale: string;
	row?: number;
	column?: number;
};

export function talentInsightsCacheKey(input: Omit<TalentInsightsStreamInput, 'locale'>): string {
	const cell = input.row != null && input.column != null ? `${input.row}:${input.column}` : '';

	return [input.userID, input.templateID, input.groupID, input.localDate, cell].join('|');
}

export function talentInsightsStreamParams(
	input: TalentInsightsStreamInput,
): Record<string, string> {
	const params: Record<string, string> = {
		userID: input.userID,
		templateID: input.templateID,
		groupID: input.groupID,
		localDate: input.localDate,
		locale: input.locale,
	};

	if (input.row != null && input.column != null) {
		params.row = String(input.row);
		params.column = String(input.column);
	}

	return params;
}
